import { Component, input, output } from "@angular/core";
import { NgStyle } from "@angular/common";

@Component({
  selector: "cloze-test-custom-checkbox",
  templateUrl: "./custom-checkbox.component.html",
  styleUrls: ["./custom-checkbox.component.scss"],
  standalone: true,
  imports: [NgStyle],
})
export class CustomCheckboxComponent {
  readonly checked = input(false);
  readonly color = input("#6852AA");
  readonly checkedChange = output<boolean>();

  toggle(): void {
    this.checkedChange.emit(!this.checked());
  }
}
